import { useContext } from 'react';

import { GlobalLoaderContext } from '../context/GlobalLoaderContext';
import type { GlobalLoaderContextType } from '../context/GlobalLoaderContext';

const useGlobalLoader = (): GlobalLoaderContextType => {
  const context = useContext(GlobalLoaderContext);

  if (context === undefined) {
    throw new Error('useGlobalLoader must be used within a GlobalLoaderProvider');
  }

  return context;
};

export default useGlobalLoader;
